import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

// api
import startupApi from '/src/apis/startupApi';
import fundingApi from '/src/apis/fundingApi';
import entityApi from '/src/apis/entityApi';

// constants
import { MAX_LIMIT } from '/src/lib/constants';

const useFetchStartupData = (id, entityType, isLoggedIn, setState) => {
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () => {
        setIsLoading(true);

        const [industriesResponse, businessTypeResponse] = await Promise.all([
            startupApi.getIndustries(id),
            startupApi.getBusinessType(id)
        ]);

        let industries = [];
        let subIndustries = [];

        if (industriesResponse?.length > 0) {
            industriesResponse.map(item => {
                if (!item.is_sub_industry) {
                    industries.push(item);
                } else if (item.is_sub_industry === 0) {
                    industries.push(item);
                } else if (item.is_sub_industry === 1) {
                    subIndustries.push(item);
                }
            });
        }

        setState(prevState => ({
            ...prevState,
            industries: industries,
            subIndustries: subIndustries,
            businessType: businessTypeResponse
        }));

        if (isLoggedIn) {

            const filters = [];
            const pathname = window.location.pathname;

            const [supportResponse, geoFocusResponse, userTeamStatusResponse, fundingDataResponse] = await Promise.all([
                startupApi.getSupportData(id),
                startupApi.getGeoFocusLocations(id),
                entityApi.getUserTeamStatus(id, entityType),
                fundingApi.getFundingData(id, entityType, MAX_LIMIT, filters, pathname)
            ]);

            let geoFocusArr = [];
            if (geoFocusResponse?.length > 0) {
                geoFocusResponse.map(item => {
                    if (!isEmpty(item.location_data))
                        geoFocusArr.push({ id: item.id, name: item.location_data.name });
                });
            }

            setState(prevState => ({
                ...prevState,
                support: supportResponse,
                owner: !isEmpty(userTeamStatusResponse) && userTeamStatusResponse.is_team_member == 1,
                showAllRounds: !isEmpty(userTeamStatusResponse) && userTeamStatusResponse.is_team_member == 1,
            }));

            if (geoFocusResponse) {
                setState(prevState => ({
                    ...prevState,
                    geoFocusData: geoFocusArr,
                    startup: {
                        ...prevState.startup,
                        geo_focus_data: geoFocusArr
                    }
                }));
            }
            if (fundingDataResponse.rounds) {
                setState(prevState => ({
                    ...prevState,
                    fundingRounds: fundingDataResponse.rounds.reverse()
                }));
            }
        }

        setIsLoading(false);
    };


    useEffect(() => {
        if (id) {
            fetchData();
        }
    }, [id, entityType]);

    return [fetchData, isLoading];
};

export default useFetchStartupData;
